import React, { useContext, useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import Style from "./style.module.css";
import Select from "react-select";
// import { GlobalContext } from "../../../context/Context";
import {
  FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
} from "../../../../component/form/form-layout";
import { GlobalContext } from "../../../../context/Context";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import LeftSidePopupLayout from "../../../../component/popup/modal-layout";
import XCloseIcon from "../../../../component/icons/x-close";

const stripHtml = (html) => (html || "").replace(/<[^>]*>?/gm, "");

const AddHealthScoreFactor = ({
  onSubmit = () => {},
  onClose = () => {},
  onError = () => {},
  editData = {},
}) => {
  let { state, dispatch } = useContext(GlobalContext);

  const apiCall = useApiCall();

  useEffect(() => {
    if (editData?.id) {
      formik.setFieldValue("factor", editData?.factor);
      formik.setFieldValue("weight", editData?.weight);
      formik.setFieldValue("good_signal", editData?.good_signal);
      formik.setFieldValue("bad_signal", editData?.bad_signal);
      formik.setFieldValue("max_points", editData?.max_points);
    }
  }, [editData]);

  const isChanged = () => {
    if (!editData?.id) return true; // new data
    return Object.keys(formik.values).some(
      (key) => formik.values[key] !== editData[key],
    );
  };

  const validationSchema = yup.object({
    factor: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    weight: yup
      .number("This Field is Required")
      .required("This Field is Required"),
    good_signal: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    bad_signal: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    max_points: yup
      .number("This Field is Required")
      .required("This Field is Required"),
  });

  const formik = useFormik({
    initialValues: {
      factor: "",
      weight: "",
      good_signal: "",
      bad_signal: "",
      max_points: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      if (!isChanged()) {
        console.log("No changes detected. API not called.");
        return;
      }
      let data = {
        factor: values.factor,
        weight: Number(values.weight),
        good_signal: values.good_signal,
        bad_signal: values.bad_signal,
        max_points: Number(values.max_points),
      };

      try {
        let apiRes;

        apiRes = await apiCall({
          method: "post",
          url: editData?.id
            ? `health-score-factors/update-factor/${editData?.id}`
            : `health-score-factors/add-factor`,
          data: data,
        });

        formik.resetForm();
        onSubmit(apiRes?.message || `Request Submitted`);
      } catch (error) {
        console.log("Error", error);
        const res = error?.response?.data;

        if (res?.errors) {
          formik.setErrors(
            Object.fromEntries(
              Object.entries(res.errors).map(([key, value]) => [key, value[0]]),
            ),
          );
        }
        onError(
          error?.response.data?.respMsg ||
            error?.response.data?.responseMessage ||
            error?.response.data?.message ||
            "Some Thing Went Wrong",
        );
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <LeftSidePopupLayout
        popupStatus={true}
        className={`${Style.addMeModal} ${Style.leaveModal} !gap-0`}
      >
        <div
          className={`${Style["modal_header"]} ${Style.addMeModal_head} !flex !justify-between !items-center`}
        >
          <h4>
            {editData?.id
              ? "Edit Health Score Factor"
              : "Add Health Score Factor"}
          </h4>
          <div
            onClick={onClose}
            className={`${Style["close_btn"]} cursor-pointer hover:text-red-500 p-1 rounded hover:bg-gray-200 transition-all duration-300`}
          >
            <XCloseIcon />
          </div>
        </div>

        <div className={`${Style.addMeModal_body}`}>
          {/* <div className={`${Style.dcmb__card}`}>
            <div className={`${Style.dcmb__cardBody}`}>
              <div className={`${Style.dcmb__cardBody_formArea} pt-3`}> */}
          <FormArea>
            {/* factor */}
            <FeildWraper width="100%">
              <FormLabel required>Factor</FormLabel>
              <input
                type="text"
                name="factor"
                value={formik.values.factor}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                placeholder="Factor"
              />
              {formik.touched.factor && formik.errors.factor && (
                <FeildError>{formik.errors.factor}</FeildError>
              )}
            </FeildWraper>

            {/* weight */}
            <FeildWraper>
              <FormLabel required>Weight</FormLabel>
              <input
                type="number"
                name="weight"
                min="0"
                value={formik.values.weight}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                placeholder="Weight"
              />
              {formik.touched.weight && formik.errors.weight && (
                <FeildError>{formik.errors.weight}</FeildError>
              )}
            </FeildWraper>
            {/* Max Points */}
            <FeildWraper>
              <FormLabel required>Max Points</FormLabel>
              {/* <input
                type="number"
                name="max_points"
                min="0"
                value={formik.values.max_points}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                placeholder="Max Points"
              /> */}
              <input
                type="text"
                name="max_points"
                inputMode="numeric"
                pattern="[0-9]*"
                value={formik.values.max_points}
                onBlur={formik.handleBlur}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  formik.setFieldValue("max_points", value);
                }}
                placeholder="Max Points"
              />

              {formik.touched.max_points && formik.errors.max_points && (
                <FeildError>{formik.errors.max_points}</FeildError>
              )}
            </FeildWraper>

            {/* Good Signal */}

            <FeildWraper>
              <FormLabel required>Good Signal</FormLabel>
              <input
                type="text"
                name="good_signal"
                value={formik.values.good_signal}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                placeholder="Good Signal"
              />
              {formik.touched.good_signal && formik.errors.good_signal && (
                <FeildError>{formik.errors.good_signal}</FeildError>
              )}
            </FeildWraper>

            {/* Bad Signal */}

            <FeildWraper>
              <FormLabel required>Bad Signal</FormLabel>
              <input
                type="text"
                name="bad_signal"
                value={formik.values.bad_signal}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                placeholder="Bad Signal"
              />
              {formik.touched.bad_signal && formik.errors.bad_signal && (
                <FeildError>{formik.errors.bad_signal}</FeildError>
              )}
            </FeildWraper>
          </FormArea>
          {/* </div>
            </div>
          </div> */}
        </div>

        <div className={`${Style.dcmb__cardFoot}`}>
          <button
            type="reset"
            className={`${Style.dcmb__cancel}`}
            onClick={onClose}
          >
            Discard
          </button>
          <button
            type="submit"
            className={`${Style.dcmb__submit} disabled:!opacity-70 disabled:!cursor-not-allowed`}
            disabled={!isChanged()}
          >
            {editData?.id ? "Update" : "Apply"}
          </button>
        </div>
      </LeftSidePopupLayout>
    </form>
  );
};

export default AddHealthScoreFactor;
